import {ProductSupplier} from "./models/ProductSupplier";
import {Product} from "./models/Product";
import {ComparatorConfig} from "./models/ComparatorConfig";
import {ProductIncentiveDetails} from "./models/ProductIncentiveDetails";
import {Module} from "../translations/models/Module";
import {PhraseItem} from "../translations/models/PhraseItem";
import {TranslationItem} from "../translations/models/TranslationItem";
import {ProductCommission} from "./models/ProductCommission";
import {PartnerHierarchy} from "./models/PartnerHierarchy";
import {AuthPolicy} from "../../backend/authorization/models/AuthPolicy";
import {AuthPolicyUsage} from "../../backend/authorization/models/AuthPolicyUsage";
import {CustomAttributeSetup} from "./models/CustomAttributeSetup";
import {EventInformation} from "./models/EventInformation";

/**
 * clones the question or form setup and removes readonly fields
 */
export function cloneMutationData(
	data: Module
		| TranslationItem
		| PhraseItem
		| ProductSupplier
		| Product
		| ComparatorConfig
		| ProductIncentiveDetails
		| ProductCommission
		| PartnerHierarchy
		| AuthPolicy
		| AuthPolicyUsage
		| CustomAttributeSetup
		| EventInformation
): any {
	return deepCloneAndFilterReadonlyFields(data);
}

function deepCloneAndFilterReadonlyFields(obj: any): any {
	if (Array.isArray(obj))
		return obj.map(deepCloneAndFilterReadonlyFields);
	
	if (typeof obj === "object") {
		const copy: any = {};
		for (const key in obj) {
			// noinspection JSUnfilteredForInLoop
			if (key.startsWith("__")) continue;
			if (key === "refKey") continue;
			if (key === "version") continue;
			if (key === "creationDateTime") continue;
			if (key === "lastModifiedDateTime") continue;
			if (key === "lastModifiedBy") continue;
			// noinspection JSUnfilteredForInLoop
			const value = obj[key];
			
			if (value === undefined) continue;
			if (value === null) continue;
			
			// noinspection JSUnfilteredForInLoop
			copy[key] = deepCloneAndFilterReadonlyFields(value);
		}
		return copy;
	}
	
	return obj;
}
